import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loopBranch"];
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import { List } from 'immutable';
import ConnectionKeys from 'automation-ui-action-features/constants/ConnectionKeys';
import BranchConnectionMixin, { BranchConnectionMixinDefaultValues, branchConnectionFromJSON } from 'automation-ui-action-features/records/connection/BranchConnectionMixin';
import WhileLoopBranch from 'automation-ui-action-features/records/WhileLoopBranch';
import ConnectionTypes from 'automation-ui-action-features/constants/ConnectionTypes';
const LoopConnectionDefaultValues = Object.assign({}, BranchConnectionMixinDefaultValues, {
  [ConnectionKeys.LOOP_BRANCH]: new WhileLoopBranch(),
  [ConnectionKeys.CONNECTION_TYPE]: ConnectionTypes.WHILE_LOOP
});
export default class LoopConnection extends BranchConnectionMixin(createImmutableObjectClass(LoopConnectionDefaultValues, {
  fromJSON: _ref => {
    let _ConnectionKeys$LOOP_ = ConnectionKeys.LOOP_BRANCH,
      {
        [_ConnectionKeys$LOOP_]: loopBranch
      } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, [_ConnectionKeys$LOOP_].map(_toPropertyKey));
    return Object.assign({}, rest, branchConnectionFromJSON(rest), {
      // TODO ZS: switch on the type of loop branch instead of defaulting
      // to the WhileLoopBranch
      loopBranch: new WhileLoopBranch(loopBranch)
    });
  },
  toJSON: _ref2 => {
    let {
        loopBranch
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
    return Object.assign({}, rest, {
      loopBranch
    });
  }
})) {
  /**
   * The `getBranches` method intentionally returns a List
   * for compatibility with other branching logic on the
   * canvas
   */
  getBranches() {
    const loopBranch = this[ConnectionKeys.LOOP_BRANCH];
    return List([loopBranch]);
  }

  /**
   * The `setBranches` method intentionally expects a List
   * for compatibility with other branching logic on the
   * canvas
   */
  setBranches(branches) {
    return this.set(ConnectionKeys.LOOP_BRANCH, branches.get(0));
  }
}